import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { AnyPropertyChanged, useEntityPropertyChangedCallback } from '../../../hooks/entity/useEntityPropertyChangedCallback';
export type EditTimeTrackingActivityCompilationFormProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  timeTrackingActivityCompilation: TimeTrackingActivityCompilation;
  onPropertyChanged: AnyPropertyChanged<TimeTrackingActivityCompilation>;
};
export const EditTimeTrackingActivityCompilationForm: FunctionComponent<EditTimeTrackingActivityCompilationFormProps> = React.memo(props => {
  const $ = _c(15);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onPropertyChanged;
  let remainingProps;
  let timeTrackingActivityCompilation;
  if ($[2] !== t0) {
    ({
      timeTrackingActivityCompilation,
      onPropertyChanged,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onPropertyChanged;
    $[4] = remainingProps;
    $[5] = timeTrackingActivityCompilation;
  } else {
    onPropertyChanged = $[3];
    remainingProps = $[4];
    timeTrackingActivityCompilation = $[5];
  }
  const {
    t
  } = useTranslation();
  const handleNameChanged = useEntityPropertyChangedCallback(timeTrackingActivityCompilation, "name", onPropertyChanged);
  let t1;
  if ($[6] !== t) {
    t1 = t("entities.TimeTrackingActivityCompilation.name");
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== handleNameChanged || $[9] !== t1 || $[10] !== timeTrackingActivityCompilation.name) {
    t2 = <BufferedTextInput label={t1} value={timeTrackingActivityCompilation.name} onInput={handleNameChanged} data-testid="EditTimeTrackingActivityCompilationForm.NameInput" />;
    $[8] = handleNameChanged;
    $[9] = t1;
    $[10] = timeTrackingActivityCompilation.name;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== remainingProps || $[13] !== t2) {
    t3 = <div {...remainingProps}>{t2}</div>;
    $[12] = remainingProps;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
});